var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"line-clamp-2"},[_vm._v("\n  "+_vm._s(_vm.generateFlagEmoji(_vm.country))+" "+_vm._s(_vm.location)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }